import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAction, TProfileTeam, TProdutoView} from "../../../app/enum";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileService} from "../../../providers/profile-service";

import {ShowtalkPage} from "../../show/showtalk/showtalk";
import {ShowsyncPage} from "../../show/showsync/showsync";
import {ShowdeskPage} from "../../show/showdesk/showdesk";
import {ShowviewPage} from "../../show/showview/showview";

import {WebstorOpenPage} from "../webstor-open/webstor-open";
import {ClusterMenuPage} from "../cluster-menu/cluster-menu";
import {ProdutoMenuPage} from "../produto-menu/produto-menu";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";


@Component({
    selector: 'page-webstor-menu',
    templateUrl: 'webstor-menu.html',
    providers: [WebstorService, ProfileService]
})

export class WebstorMenuPage {

    config: any;
    logado: any;

    manager: boolean;
    partner: boolean;
    ellzito: boolean;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, public webstorService: WebstorService,
                public logadoService: LogadoService, public profileService: ProfileService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.manager = (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        this.partner = (this.logado.Profile.ProfileTeam >= TProfileTeam.mkPartner);
        this.ellzito = (this.logado.Profile.ProfileZito && this.manager);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Webstor Menu', '/webstor-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }








    produtoMenu() {

        let objectPro = {homeb: true, etapa: 1, rootspot: null, produtoFull: true, produtoView: TProdutoView.pdDetalhe};
        this.util.modalopen(ProdutoMenuPage, 'alto', false, objectPro).subscribe();

    }

    brandedPush() {

        let objectBra = {flagstor: true, etapa: 0, rootile: this.logado, partnerID: 0};
        this.navCtrl.push(NegocioMenuPage, objectBra);

    }

    webstorPush(page, param) {

        let onBack = () => this.util.statusBarColor(TStatusBar.sbStyleDefault);
        this.util.modalopen(page, 'alto', false, param, null, null, onBack).subscribe()

    }

    webstorMenu(exec, press) {

        /** DATA **/
        let homeb = (this.ellzito && press);

        let objectSub = {homeb: homeb, etapa: 0, title: null, keyname: 'Assunto', toggler: null};
        let objectHas = {homeb: homeb, etapa: 0, title: null, keyname: 'Hashtag', toggler: null};

        let objectNeg = {homeb: homeb, etapa: 0, title: null, keyname: 'Negocio', toggler: null};
        let objectClu = {homeb: homeb, etapa: 0};

        let objectPrj = {homeb: homeb, etapa: 0, title: null, keyname: 'Projeto', toggler: null};
        let objectDep = {homeb: homeb, etapa: 0, title: null, keyname: 'Deposit', toggler: null};
        let objectDet = {homeb: homeb, etapa: 0, title: null, keyname: 'Departa', toggler: null};

        let objectPac = {homeb: homeb, etapa: 0, title: null, keyname: 'Package', toggler: null};
        let objectJus = {homeb: homeb, etapa: 0, title: null, keyname: 'Justify', toggler: null};
        let objectEsc = {homeb: homeb, etapa: 0, title: null, keyname: 'Escolha', toggler: null};

        let objectAmb = {homeb: homeb, etapa: 0, title: null, keyname: 'Ambient', toggler: null};
        let objectPra = {homeb: homeb, etapa: 0, title: null, keyname: 'Praceta', toggler: null};
        let objectMet = {homeb: homeb, etapa: 0, title: null, keyname: 'Methodo', toggler: null};


        if (exec == 'Assunto' && this.partner) this.webstorPush(WebstorOpenPage, objectSub);
      //if (exec == 'Warning' && this.partner)
        if (exec == 'Hashtag' && this.partner) this.webstorPush(WebstorOpenPage, objectHas);

        if (exec == 'Negocio' && this.partner) this.webstorPush(WebstorOpenPage, objectNeg);
        if (exec == 'Branded' && this.partner) this.brandedPush();
        if (exec == 'Cluster' && this.partner) this.webstorPush(ClusterMenuPage, objectClu);

        if (exec == 'Projeto' && this.partner) this.webstorPush(WebstorOpenPage, objectPrj);
        if (exec == 'Departa' && this.partner) this.webstorPush(WebstorOpenPage, objectDet);
        if (exec == 'Deposit' && this.partner) this.webstorPush(WebstorOpenPage, objectDep);

        if (exec == 'Package' && this.partner) this.webstorPush(WebstorOpenPage, objectPac);
        if (exec == 'Justify' && this.partner) this.webstorPush(WebstorOpenPage, objectJus);
        if (exec == 'Escolha' && this.partner) this.webstorPush(WebstorOpenPage, objectEsc);

        if (exec == 'Ambient' && this.partner) this.webstorPush(WebstorOpenPage, objectAmb);
        if (exec == 'Praceta' && this.partner) this.webstorPush(WebstorOpenPage, objectPra);
        if (exec == 'Methodo' && this.partner) this.webstorPush(WebstorOpenPage, objectMet);

    }

    webstorShow() {

        /** SHOW **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Showtalk', handler: () => this.webstorPush(ShowtalkPage, {etapa: 0})});
        if (this.partner) buttons.push({text: 'Showsync', handler: () => this.webstorPush(ShowsyncPage, {etapa: 0})});
        if (this.partner) buttons.push({text: 'Showdesk', handler: () => this.webstorPush(ShowdeskPage, {etapa: 0})});
        if (this.partner) buttons.push({text: 'Showview', handler: () => this.webstorPush(ShowviewPage, {etapa: 0, hotspotID: this.config.kairos.HotspotID})});
        this.util.sheetOpen(buttons, 'SHOWBOARD');

    }

    webstorTeam() {

        let alignL = {type: 'foto', text: '', show: 'ProfileFace', info: '', color: ''};
        let alignC = {type: 'text', text: '', show: 'ProfileShow', info: '', color: ''};
        let alignR = {type: 'text', text: '', show: 'ProfileTeam', info: '', color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.profileService.profile(TAction.acTime, 0)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Profiles),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );

        };

        let onOkuy = (okey, that, line, click, event) => {

            this.navCtrl.push(ProfilePagePage, {profileID: line.ProfileID});

        };

        let modalshow = this.config.listingForm('Team', onShow, onOkuy, alignL, alignC, alignR);
        let objectData = {profile: this.logado.Profile, modalshow: modalshow, tabmenu: false};

        this.webstorPush(ListingMenuPage, objectData);

    }


    zippackOpen() {

        /** SHOW **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Zipcity', handler: () => alert('Dev and Call this.webstorPush()')});
        buttons.push({text: 'ZipNcmc', handler: () => alert('Dev and Call this.webstorPush()')});
        buttons.push({text: 'ZipCest', handler: () => alert('Dev and Call this.webstorPush()')});
        buttons.push({text: 'ZipCesn', handler: () => alert('Dev and Call this.webstorPush()')});
        buttons.push({text: 'ZipCnae', handler: () => alert('Dev and Call this.webstorPush()')});
        buttons.push({text: 'ZipAnex', handler: () => alert('Dev and Call this.webstorPush()')});
        this.util.sheetOpen(buttons, 'ZIPPACK');

    }

    dismiss() {

        this.navCtrl.pop({animation: 'md-transition'});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/webstor-menu/webstor-menu.ts